import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';

const ACCOMPAGNEMENTS = ['Riz', 'Pâtes sautées', 'Frites', 'Légumes sautés'];

const CATS_SANS_ACCOMP = [
  'Cocktails', 'Softs', 'Boissons Chaudes', 'Cocktails Sans Alcool',
  'Whisky & Bourbons', 'Vodkas', 'Rhums Arrangés', 'Champagnes & Bulles',
  'Vins Rouges', 'Vins Blancs', 'Vins Rosés', 'Desserts', 'Petits Déjeuners'
];

export default function ServeurHome() {
  const { user, logout } = useAuth();
  const [zones, setZones] = useState([]);
  const [zoneActive, setZoneActive] = useState(null);
  const [tableActive, setTableActive] = useState(null);
  const [categories, setCategories] = useState([]);
  const [catActive, setCatActive] = useState(null);
  const [panier, setPanier] = useState([]);
  const [loading, setLoading] = useState(true);
  const [envoi, setEnvoi] = useState(false);
  const [note, setNote] = useState('');
  const [accompModal, setAccompModal] = useState(null);
  const [time, setTime] = useState(new Date());
//ito eeee
const [mesCommandes, setMesCommandes] = useState([]);
const [showMesCommandes, setShowMesCommandes] = useState(false);
  
// Modal table occupée
  const [tableModal, setTableModal] = useState(null); // table cliquée
  const [commandesTable, setCommandesTable] = useState([]);
  const [modeModification, setModeModification] = useState(false); // true = modification
  const [commandeAModifier, setCommandeAModifier] = useState(null);

  useEffect(() => {
    const fetchAll = () => {
      Promise.all([api.get('/tables'), api.get('/articles')]).then(([t, a]) => {
        setZones(t.data);
        setZoneActive(t.data[0]?.id);
        setCategories(a.data);
        setCatActive(a.data[0]?.id);
        setLoading(false);
      });
    };
    fetchAll();
    const interval = setInterval(() => {
      api.get('/tables').then(r => setZones(r.data));
    }, 5000);
    const clock = setInterval(() => setTime(new Date()), 1000);
    return () => { clearInterval(interval); clearInterval(clock); };
  }, []);

  const zonesFiltrees = zones.filter(z => z.id === zoneActive);
  const catActuelle = categories.find(c => c.id === catActive);
  const totalPanier = panier.reduce((sum, p) => sum + p.sous_total, 0);
  const sansPanier = !tableActive;

  const getStatutColor = (st) => {
    if (st === 'libre') return { bg: 'linear-gradient(145deg,#052e16,#14532d)', border: 'rgba(34,197,94,0.4)', num: '#86efac' };
    if (st === 'occupee') return { bg: 'linear-gradient(145deg,#450a0a,#7f1d1d)', border: 'rgba(239,68,68,0.4)', num: '#fca5a5' };
    return { bg: 'linear-gradient(145deg,#451a03,#78350f)', border: 'rgba(245,158,11,0.3)', num: '#fde68a' };
  };

  // Clic sur une table
  const choisirTable = async (table) => {
    if (table.statut === 'reservee') return;

    if (table.statut === 'occupee') {
      // Charger les commandes de cette table
      try {
        const res = await api.get('/commandes/table/' + table.id);
        setCommandesTable(res.data);
        setTableModal(table);
      } catch (e) {
        setTableModal(table);
        setCommandesTable([]);
      }
      return;
    }

    // Table libre → commande directe
    demarrerNouvelleCommande(table);
  };

  const demarrerNouvelleCommande = (table) => {
    setTableActive(table);
    setPanier([]);
    setNote('');
    setModeModification(false);
    setCommandeAModifier(null);
    setTableModal(null);
  };

  const demarrerModification = (table, commande) => {
    // Charge les lignes existantes dans le panier
    const panierExistant = commande.lignes.map(l => ({
      key: l.article_id + '|' + (l.note || ''),
      article_id: l.article_id,
      nom: l.article?.nom || '',
      nomDisplay: l.note ? l.article?.nom + ' (' + l.note + ')' : l.article?.nom,
      quantite: l.quantite,
      prix_unitaire: l.prix_unitaire,
      sous_total: l.sous_total,
      accompagnement: l.note && l.note.startsWith('Accompagnement : ')
        ? l.note.replace('Accompagnement : ', '') : null,
      noteKitchen: l.note || '',
    }));
    setTableActive(table);
    setPanier(panierExistant);
    setNote(commande.note || '');
    setModeModification(true);
    setCommandeAModifier(commande);
    setTableModal(null);
  };

  // Panier
  const addToPanier = (article, accompagnement) => {
    const key = article.id + '|' + (accompagnement || '');
    setPanier(prev => {
      const exist = prev.find(p => p.key === key);
      if (exist) {
        return prev.map(p =>
          p.key === key
            ? { ...p, quantite: p.quantite + 1, sous_total: (p.quantite + 1) * p.prix_unitaire }
            : p
        );
      }
      return [...prev, {
        key,
        article_id: article.id,
        nom: article.nom,
        nomDisplay: accompagnement ? article.nom + ' + ' + accompagnement : article.nom,
        quantite: 1,
        prix_unitaire: article.prix_unitaire,
        sous_total: article.prix_unitaire,
        accompagnement: accompagnement || null,
        noteKitchen: accompagnement ? 'Accompagnement : ' + accompagnement : '',
      }];
    });
  };

  const retirerDuPanier = (key) => {
    setPanier(prev => {
      const exist = prev.find(p => p.key === key);
      if (exist?.quantite === 1) return prev.filter(p => p.key !== key);
      return prev.map(p =>
        p.key === key
          ? { ...p, quantite: p.quantite - 1, sous_total: (p.quantite - 1) * p.prix_unitaire }
          : p
      );
    });
  };

  const ouvrirAccomp = (article) => setAccompModal(article);

  const choisirAccomp = (accomp) => {
    if (!accompModal) return;
    addToPanier(accompModal, accomp);
    setAccompModal(null);
  };

  // Envoyer commande normale
  const envoyerCommande = async () => {
    if (!tableActive || panier.length === 0) return;
    setEnvoi(true);
    try {
      await api.post('/commandes', {
        table_id: tableActive.id,
        note,
        lignes: panier.map(p => ({
          article_id: p.article_id,
          quantite: p.quantite,
          note: p.accompagnement ? 'Accompagnement : ' + p.accompagnement : '',
        }))
      });
      reinitialiser();
    } catch (e) {
      alert("Erreur lors de l'envoi");
    } finally {
      setEnvoi(false);
    }
  };
  //ito e
  const chargerMesCommandes = async () => {
  const res = await api.get('/commandes');
  const miennes = res.data.filter(c => c.serveur === user?.name);
  setMesCommandes(miennes);
  setShowMesCommandes(true);
};

const getTemps = (created_at) => {
  const diff = Math.floor((new Date() - new Date(created_at)) / 60000);
  if (diff < 1) return '< 1 min';
  if (diff < 60) return diff + ' min';
  return Math.floor(diff / 60) + 'h ' + (diff % 60) + 'min';
};

  // Renvoyer commande modifiée
  const renvoyerModification = async () => {
    if (!tableActive || panier.length === 0 || !commandeAModifier) return;
    setEnvoi(true);
    try {
      // 1. Annuler l'ancienne commande
      await api.put('/commandes/' + commandeAModifier.id + '/statut', { statut: 'annule' });

      // 2. Créer la nouvelle avec tag MODIFIÉE
      await api.post('/commandes', {
        table_id: tableActive.id,
        note: '⚠️ COMMANDE MODIFIÉE' + (note ? ' — ' + note : ''),
        lignes: panier.map(p => ({
          article_id: p.article_id,
          quantite: p.quantite,
          note: p.accompagnement ? 'Accompagnement : ' + p.accompagnement : '',
        }))
      });

      reinitialiser();
    } catch (e) {
      alert("Erreur lors de la modification");
    } finally {
      setEnvoi(false);
    }
  };

  const reinitialiser = () => {
    setPanier([]);
    setNote('');
    setTableActive(null);
    setModeModification(false);
    setCommandeAModifier(null);
    api.get('/tables').then(r => setZones(r.data));
  };

  if (loading) return (
    <div style={s.loading}>
      <div style={s.loadLogo}>VAH'INN</div>
      <div style={s.loadSub}>Chargement...</div>
    </div>
  );

  return (
    <div style={s.app}>
      <style>{css}</style>

      {/* MODAL TABLE OCCUPÉE */}
      {tableModal && (
        <div style={s.overlay} onClick={() => setTableModal(null)}>
          <div style={s.tableOccupeeModal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div>
                <div style={s.modalTitle}>Table {tableModal.numero}</div>
                <div style={s.modalSub}>
                  {zones.find(z => z.tables?.some(t => t.id === tableModal.id))?.nom} — Occupée
                </div>
              </div>
              <button style={s.closeBtn} onClick={() => setTableModal(null)}>✕</button>
            </div>

            {/* Commandes en cours */}
            {commandesTable.length > 0 && (
              <div style={s.commandesEnCours}>
                <div style={s.commandesLabel}>Commandes en cours</div>
                {commandesTable.map(cmd => (
                  <div key={cmd.id} style={s.cmdResume}>
                    <div style={s.cmdResumeHeader}>
                      <span style={s.cmdResumeStatut}>
                        {cmd.statut === 'en_attente' ? '⏳ En attente'
                          : cmd.statut === 'en_cuisine' ? '👨‍🍳 En cuisine'
                          : '✅ Prêt'}
                      </span>
                      <span style={s.cmdResumeTotal}>{cmd.total?.toLocaleString()} Ar</span>
                    </div>
                    <div style={s.cmdResumeLignes}>
                      {cmd.lignes?.map(l => (
                        <div key={l.id} style={s.cmdResumeLigne}>
                          <span style={s.cmdResumeLigneQte}>x{l.quantite}</span>
                          <span style={s.cmdResumeLigneNom}>{l.article?.nom}</span>
                          {l.note && <span style={s.cmdResumeLigneNote}>{l.note}</span>}
                        </div>
                      ))}
                    </div>
                    {/* Bouton modifier cette commande */}
                    <button
                      style={s.btnModifier}
                      onClick={() => demarrerModification(tableModal, cmd)}
                    >
                      ✏️ Modifier cette commande
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* Bouton ajouter nouvelle commande */}
            <button
              style={s.btnAjouter}
              onClick={() => demarrerNouvelleCommande(tableModal)}
            >
              + Ajouter une commande
            </button>
          </div>
        </div>
      )}

      {/* MODAL ACCOMPAGNEMENT */}
      {accompModal && (
        <div style={s.overlay} onClick={() => setAccompModal(null)}>
          <div style={s.accompModal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>Choisir un accompagnement</div>
            <div style={s.accompPlat}>{accompModal.nom}</div>
            <div style={s.accompGrid}>
              {ACCOMPAGNEMENTS.map(a => (
                <button key={a} style={s.accompChoixBtn} onClick={() => choisirAccomp(a)}>
                  🍽 {a}
                </button>
              ))}
            </div>
            <button style={s.accompAnnuler} onClick={() => setAccompModal(null)}>
              Annuler
            </button>
          </div>
        </div>
      )}
       {showMesCommandes && (
  <div style={s.overlay} onClick={() => setShowMesCommandes(false)}>
    <div style={{...s.tableOccupeeModal, borderColor:'rgba(99,102,241,0.3)', maxWidth:'520px'}} onClick={e => e.stopPropagation()}>
      <div style={s.modalHeader}>
        <div>
          <div style={s.modalTitle}>Mes commandes</div>
          <div style={s.modalSub}>{mesCommandes.length} commande(s) en cours</div>
        </div>
        <button style={s.closeBtn} onClick={() => setShowMesCommandes(false)}>✕</button>
      </div>

      {mesCommandes.length === 0 ? (
        <div style={{textAlign:'center', color:'#475569', padding:'32px'}}>
          Aucune commande en cours
        </div>
      ) : (
        <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
          {mesCommandes.map(cmd => (
            <div key={cmd.id} style={{background:'rgba(15,23,42,0.8)', border:'1px solid rgba(51,65,85,0.5)', borderRadius:'14px', padding:'14px'}}>
              <div style={{display:'flex', justifyContent:'space-between', marginBottom:'10px'}}>
                <div>
                  <span style={{fontSize:'22px', fontWeight:'900', color:'#f1f5f9'}}>{cmd.table?.numero}</span>
                  <span style={{fontSize:'12px', color:'#64748b', marginLeft:'8px'}}>{cmd.table?.zone?.nom}</span>
                </div>
                <div style={{textAlign:'right'}}>
                  <div style={{
                    fontSize:'12px', fontWeight:'600', padding:'3px 10px', borderRadius:'12px',
                    background: cmd.statut === 'pret' ? 'rgba(34,197,94,0.15)' : cmd.statut === 'en_cuisine' ? 'rgba(245,158,11,0.15)' : 'rgba(239,68,68,0.15)',
                    color: cmd.statut === 'pret' ? '#86efac' : cmd.statut === 'en_cuisine' ? '#fde68a' : '#fca5a5',
                  }}>
                    {cmd.statut === 'pret' ? '✅ Prêt' : cmd.statut === 'en_cuisine' ? '👨‍🍳 En cuisine' : '⏳ En attente'}
                  </div>
                  <div style={{fontSize:'11px', color:'#f59e0b', marginTop:'4px', fontWeight:'700'}}>
                    ⏱ {getTemps(cmd.created_at)}
                  </div>
                </div>
              </div>

              <div style={{display:'flex', flexDirection:'column', gap:'4px'}}>
                {cmd.lignes?.map((l, i) => (
                  <div key={i} style={{display:'flex', gap:'8px', fontSize:'13px'}}>
                    <span style={{color:'#f59e0b', fontWeight:'700'}}>x{l.quantite}</span>
                    <span style={{color:'#cbd5e1'}}>{l.article?.nom}</span>
                    {l.note && <span style={{color:'#a5b4fc', fontStyle:'italic'}}>({l.note})</span>}
                  </div>
                ))}
              </div>

              <div style={{marginTop:'10px', display:'flex', justifyContent:'space-between', borderTop:'1px solid rgba(51,65,85,0.4)', paddingTop:'8px'}}>
                <span style={{fontSize:'11px', color:'#64748b'}}>Total</span>
                <span style={{fontSize:'15px', fontWeight:'800', color:'#f59e0b'}}>{cmd.total?.toLocaleString()} Ar</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
)}
      {/* HEADER */}
      <header style={s.header}>
        <div style={s.headerLeft}>
          <span style={s.logo}>VAH'INN</span>
          <span style={s.logoDivider}>·</span>
          <span style={s.logoSub}>Service</span>
        </div>
        <div>
          <span style={s.clock}>
            {time.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
        <div style={s.headerRight}>
          {tableActive && (
            <div style={{
              ...s.tableActiveBadge,
              ...(modeModification ? s.tableActiveBadgeModif : {})
            }}>
              {modeModification ? '✏️ Modif. Table ' : 'Table '}{tableActive.numero}
            </div>
          )}
          <div style={s.userPill}>
            <span style={s.userAvatar}>{user?.name?.charAt(0)}</span>
            <span style={s.userName}>{user?.name}</span>
          </div>
          <button style={s.logoutBtn} onClick={logout}>⏻</button>
        </div>
        //ito eee
        <button
  style={s.mesCommandesBtn}
  onClick={chargerMesCommandes}
>
  📋 Mes commandes
</button>
      </header>

      {/* BODY 3 COLONNES */}
      <div style={s.body}>

        {/* COL 1 — TABLES */}
        <div style={s.col1}>
          <div style={s.colTitle}>Tables</div>
          <div style={s.zoneTabs}>
            {zones.map(z => (
              <button
                key={z.id}
                style={{...s.zoneTab, ...(zoneActive === z.id ? s.zoneTabActive : {})}}
                onClick={() => setZoneActive(z.id)}
              >
                {z.nom}
              </button>
            ))}
          </div>
          <div style={s.tablesGrid}>
            {zonesFiltrees[0]?.tables?.map(table => {
              const col = getStatutColor(table.statut);
              const isSelected = tableActive?.id === table.id;
              return (
                <button
                  key={table.id}
                  style={{
                    ...s.tableBtn,
                    background: col.bg,
                    border: isSelected ? '2px solid #f59e0b' : '1px solid ' + col.border,
                    boxShadow: isSelected ? '0 0 0 3px rgba(245,158,11,0.2)' : 'none',
                    cursor: table.statut === 'reservee' ? 'not-allowed' : 'pointer',
                    opacity: table.statut === 'reservee' ? 0.5 : 1,
                  }}
                  onClick={() => choisirTable(table)}
                >
                  <span style={{...s.tableNum, color: col.num}}>{table.numero}</span>
                  <span style={s.tableStatut}>
                    {table.statut === 'libre' ? 'Libre'
                      : table.statut === 'occupee' ? 'Occupée'
                      : 'Réservée'}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* COL 2 — MENU */}
        <div style={s.col2}>
          <div style={s.colTitle}>
            {modeModification
              ? '✏️ Modification — Table ' + tableActive?.numero
              : tableActive
                ? 'Menu — Table ' + tableActive.numero
                : 'Sélectionnez une table'}
          </div>
          <div style={s.catTabs}>
            {categories.map(c => (
              <button
                key={c.id}
                style={{...s.catTab, ...(catActive === c.id ? s.catTabActive : {})}}
                onClick={() => setCatActive(c.id)}
              >
                {c.nom}
              </button>
            ))}
          </div>
          <div style={s.articlesGrid}>
            {catActuelle?.articles?.map(article => {
              const qteTotal = panier
                .filter(p => p.article_id === article.id)
                .reduce((sum, p) => sum + p.quantite, 0);
              const isSansAccomp = CATS_SANS_ACCOMP.includes(catActuelle?.nom);
              return (
                <div
                  key={article.id}
                  style={{
                    ...s.articleCard,
                    ...(qteTotal > 0 ? s.articleCardActive : {}),
                    opacity: sansPanier ? 0.4 : 1,
                  }}
                >
                  <div style={s.articleTop}>
                    <span style={s.articleNom}>{article.nom}</span>
                    {qteTotal > 0 && (
                      <span style={s.articleQteBadge}>x{qteTotal}</span>
                    )}
                  </div>
                  <div style={s.articleBottom}>
                    <span style={s.articlePrix}>
                      {article.prix_unitaire.toLocaleString()} Ar
                    </span>
                    <div style={s.articleBtns}>
                      {!isSansAccomp && (
                        <button
                          style={{...s.accompBtn2, opacity: sansPanier ? 0.3 : 1}}
                          disabled={sansPanier}
                          onClick={() => !sansPanier && ouvrirAccomp(article)}
                        >
                          🍽 Accomp.
                        </button>
                      )}
                      <button
                        style={{...s.addBtn, opacity: sansPanier ? 0.3 : 1}}
                        disabled={sansPanier}
                        onClick={() => !sansPanier && addToPanier(article, null)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* COL 3 — PANIER */}
        <div style={s.col3}>
          <div style={{...s.colTitle, display:'flex', justifyContent:'space-between', alignItems:'center', padding:'12px 14px 8px'}}>
            <span>{modeModification ? '✏️ Modification' : 'Commande'}</span>
            {panier.length > 0 && (
              <button style={s.clearBtn} onClick={() => setPanier([])}>Vider</button>
            )}
          </div>

          {modeModification && (
            <div style={s.modifBanner}>
              ⚠️ Modification en cours — l'ancienne commande sera annulée
            </div>
          )}

          {tableActive ? (
            <div style={s.tableInfoBar}>
              <span style={s.tableInfoNum}>Table {tableActive.numero}</span>
              <span style={s.tableInfoZone}>
                {zones.find(z => z.tables?.some(t => t.id === tableActive.id))?.nom}
              </span>
            </div>
          ) : (
            <div style={s.noTable}>Aucune table sélectionnée</div>
          )}

          <div style={s.panierList}>
            {panier.length === 0 ? (
              <div style={s.panierEmpty}>Le panier est vide</div>
            ) : (
              panier.map((item) => (
                <div key={item.key} style={s.panierItem}>
                  <div style={s.panierLeft}>
                    <span style={s.panierNom}>{item.nom}</span>
                    {item.accompagnement && (
                      <span style={s.panierAccomp}>+ {item.accompagnement}</span>
                    )}
                    <span style={s.panierPrix}>{item.sous_total.toLocaleString()} Ar</span>
                  </div>
                  <div style={s.qteCtrl}>
                    <button style={s.qteMoins} onClick={() => retirerDuPanier(item.key)}>−</button>
                    <span style={s.qteNum}>{item.quantite}</span>
                    <button
                      style={s.qtePlus}
                      onClick={() => addToPanier(
                        { id: item.article_id, nom: item.nom, prix_unitaire: item.prix_unitaire },
                        item.accompagnement
                      )}
                    >+</button>
                  </div>
                </div>
              ))
            )}
          </div>

          <textarea
            style={s.noteInput}
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="Note pour la cuisine..."
            rows={2}
          />

          <div style={s.totalRow}>
            <span style={s.totalLabel}>Total estimé</span>
            <span style={s.totalMontant}>{totalPanier.toLocaleString()} Ar</span>
          </div>

          <button
            style={s.changerBtn}
            onClick={reinitialiser}
          >
            {modeModification ? 'Annuler la modification' : 'Changer de table'}
          </button>

          {modeModification ? (
            <button
              style={{
                ...s.renvoyerBtn,
                ...(!tableActive || panier.length === 0 || envoi ? s.envoyerDisabled : {})
              }}
              onClick={renvoyerModification}
              disabled={!tableActive || panier.length === 0 || envoi}
            >
              {envoi ? 'Envoi...' : '✏️ Renvoyer en cuisine'}
            </button>
          ) : (
            <button
              style={{
                ...s.envoyerBtn,
                ...(!tableActive || panier.length === 0 || envoi ? s.envoyerDisabled : {})
              }}
              onClick={envoyerCommande}
              disabled={!tableActive || panier.length === 0 || envoi}
            >
              {envoi ? 'Envoi...' : 'Envoyer en cuisine'}
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

const css = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0a0f1e; overflow: hidden; }
  button { cursor: pointer; transition: transform 0.12s, opacity 0.12s; }
  button:active { transform: scale(0.94) !important; }
  button:disabled { cursor: not-allowed; }
  textarea { font-family: inherit; }
  textarea:focus { outline: none; }
  ::-webkit-scrollbar { width: 3px; height: 3px; }
  ::-webkit-scrollbar-thumb { background: #1e293b; border-radius: 2px; }
`;

const s = {
  app: {
    height: '100vh', display: 'flex', flexDirection: 'column',
    background: 'linear-gradient(160deg,#0a0f1e 0%,#0f172a 100%)',
    fontFamily: "'Segoe UI',system-ui,sans-serif",
    color: '#e2e8f0', overflow: 'hidden',
  },
  loading: {
    height: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    background: '#0a0f1e', gap: '12px',
  },
  loadLogo: { fontSize: '40px', fontWeight: '900', letterSpacing: '8px', color: '#f59e0b' },
  loadSub: { fontSize: '13px', color: '#64748b', letterSpacing: '3px' },

  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
   mesCommandesBtn: {
  background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.3)',
  color: '#a5b4fc', padding: '6px 14px', borderRadius: '20px',
  fontSize: '12px', fontWeight: '600',
},

  // MODAL TABLE OCCUPÉE
  tableOccupeeModal: {
    background: 'linear-gradient(145deg,#0f172a,#1e293b)',
    border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: '22px', padding: '24px',
    width: '480px', maxHeight: '85vh', overflowY: 'auto',
    display: 'flex', flexDirection: 'column', gap: '16px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
  },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  modalTitle: { fontSize: '22px', fontWeight: '800', color: '#f1f5f9' },
  modalSub: { fontSize: '13px', color: '#64748b', marginTop: '2px' },
  closeBtn: {
    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
    color: '#ef4444', width: '34px', height: '34px', borderRadius: '50%', fontSize: '16px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  commandesEnCours: { display: 'flex', flexDirection: 'column', gap: '10px' },
  commandesLabel: { fontSize: '11px', color: '#64748b', letterSpacing: '2px', textTransform: 'uppercase' },
  cmdResume: {
    background: 'rgba(15,23,42,0.8)', border: '1px solid rgba(51,65,85,0.5)',
    borderRadius: '14px', padding: '14px', display: 'flex', flexDirection: 'column', gap: '10px',
  },
  cmdResumeHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  cmdResumeStatut: { fontSize: '13px', fontWeight: '600', color: '#fde68a' },
  cmdResumeTotal: { fontSize: '16px', fontWeight: '800', color: '#f59e0b' },
  cmdResumeLignes: { display: 'flex', flexDirection: 'column', gap: '4px' },
  cmdResumeLigne: { display: 'flex', alignItems: 'center', gap: '8px' },
  cmdResumeLigneQte: {
    background: 'rgba(245,158,11,0.15)', color: '#f59e0b',
    padding: '1px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: '700',
  },
  cmdResumeLigneNom: { fontSize: '13px', color: '#cbd5e1', flex: 1 },
  cmdResumeLigneNote: { fontSize: '11px', color: '#a5b4fc', fontStyle: 'italic' },
  btnModifier: {
    padding: '10px', borderRadius: '10px',
    background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)',
    color: '#fde68a', fontSize: '13px', fontWeight: '600',
  },
  btnAjouter: {
    padding: '14px', borderRadius: '14px',
    background: 'linear-gradient(135deg,#16a34a,#15803d)',
    border: 'none', color: '#fff', fontSize: '15px', fontWeight: '700',
    boxShadow: '0 4px 16px rgba(22,163,74,0.25)',
  },

  // MODAL ACCOMPAGNEMENT
  accompModal: {
    background: 'linear-gradient(145deg,#0f172a,#1e293b)',
    border: '1px solid rgba(245,158,11,0.35)',
    borderRadius: '22px', padding: '28px',
    width: '400px', display: 'flex', flexDirection: 'column', gap: '18px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.7)',
  },
  accompPlat: { fontSize: '13px', color: '#f59e0b', marginTop: '-10px', fontWeight: '600' },
  accompGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' },
  accompChoixBtn: {
    display: 'flex', alignItems: 'center', gap: '10px',
    padding: '16px', borderRadius: '14px',
    background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)',
    color: '#fde68a', fontSize: '15px', fontWeight: '600',
  },
  accompAnnuler: {
    padding: '12px', borderRadius: '12px',
    background: 'rgba(100,116,139,0.12)', border: '1px solid rgba(100,116,139,0.25)',
    color: '#94a3b8', fontSize: '14px',
  },
  

  // HEADER
  header: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 20px', height: '52px',
    background: 'rgba(15,23,42,0.98)',
    borderBottom: '1px solid rgba(245,158,11,0.12)',
    flexShrink: 0,
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: '8px' },
  logo: { fontSize: '18px', fontWeight: '900', letterSpacing: '4px', color: '#f59e0b' },
  logoDivider: { fontSize: '18px', color: '#334155' },
  logoSub: { fontSize: '11px', color: '#64748b', letterSpacing: '2px', textTransform: 'uppercase' },
  clock: { fontSize: '22px', fontWeight: '700', color: '#f1f5f9', letterSpacing: '2px' },
  headerRight: { display: 'flex', alignItems: 'center', gap: '10px' },
  tableActiveBadge: {
    background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.35)',
    color: '#f59e0b', padding: '4px 14px', borderRadius: '20px', fontSize: '13px', fontWeight: '700',
  },
  tableActiveBadgeModif: {
    background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.35)', color: '#fca5a5',
  },
  userPill: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: 'rgba(30,41,59,0.7)', padding: '4px 12px 4px 4px',
    borderRadius: '20px', border: '1px solid rgba(51,65,85,0.5)',
  },
  userAvatar: {
    width: '28px', height: '28px', borderRadius: '50%',
    background: 'linear-gradient(135deg,#f59e0b,#d97706)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '12px', fontWeight: '700', color: '#0a0f1e',
  },
  userName: { fontSize: '12px', fontWeight: '600', color: '#cbd5e1' },
  logoutBtn: {
    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.25)',
    color: '#ef4444', width: '32px', height: '32px', borderRadius: '50%', fontSize: '15px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },

  // BODY
  body: {
    display: 'grid', gridTemplateColumns: '210px 1fr 255px',
    flex: 1, overflow: 'hidden',
  },
  colTitle: {
    fontSize: '11px', fontWeight: '700', letterSpacing: '2px',
    textTransform: 'uppercase', color: '#64748b',
    padding: '12px 14px 8px',
    borderBottom: '1px solid rgba(51,65,85,0.35)',
    flexShrink: 0,
  },

  // COL 1
  col1: {
    borderRight: '1px solid rgba(51,65,85,0.4)',
    display: 'flex', flexDirection: 'column',
    overflow: 'hidden', background: 'rgba(10,15,30,0.4)',
  },
  zoneTabs: {
    display: 'flex', flexWrap: 'wrap', gap: '4px',
    padding: '8px', borderBottom: '1px solid rgba(51,65,85,0.3)', flexShrink: 0,
  },
  zoneTab: {
    padding: '4px 10px', borderRadius: '10px', fontSize: '11px', fontWeight: '500',
    background: 'rgba(30,41,59,0.6)', border: '1px solid rgba(51,65,85,0.4)', color: '#64748b',
  },
  zoneTabActive: {
    background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.4)', color: '#f59e0b',
  },
  tablesGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px',
    padding: '10px', overflowY: 'auto', flex: 1, alignContent: 'start',
  },
  tableBtn: {
    borderRadius: '14px', padding: '14px 8px',
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
    transition: 'transform 0.12s, box-shadow 0.12s',
  },
  tableNum: { fontSize: '24px', fontWeight: '900', lineHeight: 1 },
  tableStatut: { fontSize: '10px', color: '#94a3b8', letterSpacing: '0.5px' },

  // COL 2
  col2: { display: 'flex', flexDirection: 'column', overflow: 'hidden' },
  catTabs: {
    display: 'flex', overflowX: 'auto', gap: '4px',
    padding: '8px 10px', borderBottom: '1px solid rgba(51,65,85,0.3)', flexShrink: 0,
  },
  catTab: {
    padding: '5px 13px', borderRadius: '14px', fontSize: '12px', fontWeight: '500',
    background: 'rgba(30,41,59,0.6)', border: '1px solid rgba(51,65,85,0.4)',
    color: '#64748b', whiteSpace: 'nowrap',
  },
  catTabActive: {
    background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.4)', color: '#f59e0b',
  },
  articlesGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(175px,1fr))',
    gap: '10px', padding: '12px', overflowY: 'auto', flex: 1, alignContent: 'start',
  },
  articleCard: {
    background: 'rgba(15,23,42,0.8)', border: '1px solid rgba(51,65,85,0.5)',
    borderRadius: '14px', padding: '12px',
    display: 'flex', flexDirection: 'column', gap: '8px',
    transition: 'border-color 0.2s',
  },
  articleCardActive: {
    background: 'rgba(245,158,11,0.05)', border: '1px solid rgba(245,158,11,0.3)',
  },
  articleTop: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '6px' },
  articleNom: { fontSize: '13px', fontWeight: '500', color: '#e2e8f0', lineHeight: 1.3, flex: 1 },
  articleQteBadge: {
    background: 'rgba(245,158,11,0.2)', color: '#f59e0b',
    fontSize: '11px', fontWeight: '700', padding: '1px 7px', borderRadius: '8px', flexShrink: 0,
  },
  articleBottom: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '4px' },
  articlePrix: { fontSize: '12px', color: '#94a3b8', fontWeight: '600' },
  articleBtns: { display: 'flex', gap: '5px', alignItems: 'center' },
  accompBtn2: {
    padding: '5px 8px', borderRadius: '8px', fontSize: '10px', fontWeight: '600',
    background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.3)',
    color: '#a5b4fc', whiteSpace: 'nowrap',
  },
  addBtn: {
    width: '28px', height: '28px', borderRadius: '50%', fontSize: '20px',
    background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.35)',
    color: '#86efac', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', lineHeight: 1, flexShrink: 0,
  },

  // COL 3
  col3: {
    borderLeft: '1px solid rgba(51,65,85,0.4)',
    display: 'flex', flexDirection: 'column',
    overflow: 'hidden', background: 'rgba(10,15,30,0.4)',
  },
  modifBanner: {
    padding: '8px 14px', fontSize: '11px', fontWeight: '600',
    background: 'rgba(239,68,68,0.1)', color: '#fca5a5',
    borderBottom: '1px solid rgba(239,68,68,0.2)', flexShrink: 0,
  },
  tableInfoBar: {
    display: 'flex', alignItems: 'baseline', gap: '8px',
    padding: '8px 14px', borderBottom: '1px solid rgba(51,65,85,0.3)', flexShrink: 0,
  },
  tableInfoNum: { fontSize: '24px', fontWeight: '900', color: '#f1f5f9' },
  tableInfoZone: { fontSize: '12px', color: '#64748b' },
  noTable: {
    padding: '10px 14px', fontSize: '12px', color: '#475569',
    borderBottom: '1px solid rgba(51,65,85,0.3)', flexShrink: 0,
  },
  clearBtn: {
    fontSize: '11px', color: '#ef4444',
    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)',
    padding: '3px 10px', borderRadius: '8px',
  },
  panierList: {
    flex: 1, overflowY: 'auto', padding: '8px 10px',
    display: 'flex', flexDirection: 'column', gap: '6px',
  },
  panierEmpty: { fontSize: '12px', color: '#475569', textAlign: 'center', padding: '24px 0' },
  panierItem: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    background: 'rgba(15,23,42,0.8)', border: '1px solid rgba(51,65,85,0.4)',
    borderRadius: '10px', padding: '8px 10px', gap: '6px',
  },
  panierLeft: { display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minWidth: 0 },
  panierNom: {
    fontSize: '12px', fontWeight: '600', color: '#e2e8f0',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  panierAccomp: { fontSize: '10px', color: '#a5b4fc', fontStyle: 'italic' },
  panierPrix: { fontSize: '11px', color: '#64748b' },
  qteCtrl: { display: 'flex', alignItems: 'center', gap: '5px', flexShrink: 0 },
  qteMoins: {
    width: '22px', height: '22px', borderRadius: '50%', fontSize: '14px',
    background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)',
    color: '#fca5a5', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  qtePlus: {
    width: '22px', height: '22px', borderRadius: '50%', fontSize: '14px',
    background: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.3)',
    color: '#86efac', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  qteNum: { fontSize: '14px', fontWeight: '700', color: '#f1f5f9', minWidth: '14px', textAlign: 'center' },
  noteInput: {
    margin: '0 10px 6px', padding: '8px 10px',
    background: 'rgba(15,23,42,0.8)', border: '1px solid rgba(51,65,85,0.4)',
    borderRadius: '10px', color: '#e2e8f0', fontSize: '12px', resize: 'none', flexShrink: 0,
  },
  totalRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '10px 14px', borderTop: '1px solid rgba(51,65,85,0.4)', flexShrink: 0,
  },
  totalLabel: { fontSize: '11px', color: '#64748b', textTransform: 'uppercase', letterSpacing: '1px' },
  totalMontant: { fontSize: '20px', fontWeight: '900', color: '#f59e0b' },
  changerBtn: {
    margin: '0 10px 6px', padding: '10px',
    background: 'rgba(51,65,85,0.35)', border: '1px solid rgba(51,65,85,0.5)',
    borderRadius: '12px', color: '#94a3b8', fontSize: '13px', fontWeight: '600', flexShrink: 0,
  },
  envoyerBtn: {
    margin: '0 10px 14px', padding: '15px',
    background: 'linear-gradient(135deg,#16a34a,#15803d)',
    border: 'none', borderRadius: '14px',
    color: '#fff', fontSize: '15px', fontWeight: '700',
    boxShadow: '0 4px 20px rgba(22,163,74,0.25)', flexShrink: 0,
  },
  renvoyerBtn: {
    margin: '0 10px 14px', padding: '15px',
    background: 'linear-gradient(135deg,#d97706,#b45309)',
    border: 'none', borderRadius: '14px',
    color: '#fff', fontSize: '15px', fontWeight: '700',
    boxShadow: '0 4px 20px rgba(217,119,6,0.25)', flexShrink: 0,
  },
  envoyerDisabled: { opacity: 0.35 },
};
